export class RsvpProfileDTO {
  firstName: string = "";
  lastName: string = "";
  username: string = "";
  email: string = "";
  language: string = "";
  address: string = "";
  dob: string = "";
  city: string = "";
  state: string = "";
  zipCode: string = "";
  phone: string = "";
  gender: string = "";
  profilePicUrl: any;
  profilePicUri: File | string = "";
  profilePicId: number = 0;

  constructor(data: Partial<RsvpProfileDTO> = {}) {
    Object.assign(this, data);
  }
}
